import {
  Box,
  CardContent,
  Grid,
  Stack,
  styled,
  Typography,
} from "@mui/material";

export const StyledProviderReviewInfoHeadingBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const StyledProviderReviewInfoCardStack = styled(Stack)(() => ({
  maxWidth: "504px",
}));

export const StyledProviderReviewInfoGridResponsive = styled(Grid)(
  ({ theme }) => ({
    [theme.breakpoints.up("xs")]: {
      marginTop: theme.spacing(4),
    },
    [theme.breakpoints.up("md")]: {
      marginTop: 0,
    },
  })
);

export const StyledProviderReviewInfoCardContent = styled(CardContent)(
  ({ theme }) => ({
    padding: theme.spacing(3),
  })
);

export const StyledPersonalInfoFieldsTypography = styled(Typography)(() => ({
  wordWrap: "break-word",
}));

export const StyledPersonalInfoFieldGrid = styled(Grid)(() => ({
  "&.MuiGrid-root": {
    marginLeft: "-16px",
    marginRight: "-16px",
  },
}));
